/**
 * Decisions about whether the session is gone, kept out of React so they can be
 * unit-tested. Web counterpart to `apps/mobile/src/lib/mobile-session-expiry-core.ts`.
 */

/**
 * Whether `authClient.useSession()` is REPORTING an absent session.
 *
 * A signal to go and re-check, NOT a verdict. Callers must not act on it
 * directly — hand it to the route guard (`router.invalidate()`), which reads
 * the server. `useKeepAuthSessionSubscribed` keeps the store tracking so this
 * stays close to the truth, but it is still a client cache and a cache is
 * never grounds for signing someone out.
 */
export const isSessionAbsenceConfirmed = ({
  hasUser,
  isPending,
  hasError,
  errorStatus,
}: {
  hasUser: boolean;
  isPending: boolean;
  hasError: boolean;
  errorStatus: number | null;
}) => !hasUser && !isPending && (!hasError || errorStatus === 401);
